import { ObjLanguage } from '../inteface';
import type { TuiCountryIsoCode, TuiLanguageName } from '@taiga-ui/i18n/types';
/**
 * Количество вопросов в уровне
 * */

export const POINT_CONFIG = {
  addPointTrueAns: 10, // кол-во баллов при правельном ответе
};
export const KEY_LANG = {
  AR: 'SA',
  BY: 'BY',
  CN: 'CN',
  NL: 'NL',
  GB: 'GB',
  FR: 'FR',
  DE: 'DE',
  ID: 'ID',
  IL: 'IL',
  IT: 'IT',
  JP: 'JP',
  KZ: 'KZ',
  KR: 'KR',
  LT: 'LT',
  MY: 'MY',
  PL: 'PL',
  PT: 'PT',
  RU: 'RU',
  ES: 'ES',
  TR: 'TR',
  UA: 'UA',
  VN: 'VN',
};
export const VAL_LANG = {
  arabic: 'arabic',
  belarus: 'belarus',
  chinese: 'chinese',
  dutch: 'dutch',
  english: 'english',
  french: 'french',
  german: 'german',
  indonesian: 'indonesian',
  hebrew: 'hebrew',
  italian: 'italian',
  japan: 'japan',
  kazakh: 'kazakh',
  korean: 'korean',
  lithuanian: 'lithuanian',
  malay: 'malay',
  polish: 'polish',
  portuguese: 'portuguese',
  russian: 'russian',
  spanish: 'spanish',
  turkish: 'turkish',
  ukrainian: 'ukrainian',
  vietnamese: 'vietnamese',
};

export const LANG_OBJ = {
  AR: {
    title: VAL_LANG.arabic,
    key: KEY_LANG.AR,
  },
  BY: {
    title: VAL_LANG.belarus,
    key: KEY_LANG.BY,
  },
  CN: {
    title: VAL_LANG.chinese,
    key: KEY_LANG.CN,
  },
  NL: {
    title: VAL_LANG.dutch,
    key: KEY_LANG.NL,
  },
  GB: {
    title: VAL_LANG.english,
    key: KEY_LANG.GB,
  },
  FR: {
    title: VAL_LANG.french,
    key: KEY_LANG.FR,
  },
  DE: {
    title: VAL_LANG.german,
    key: KEY_LANG.DE,
  },
  ID: {
    title: VAL_LANG.indonesian,
    key: KEY_LANG.ID,
  },
  IL: {
    title: VAL_LANG.hebrew,
    key: KEY_LANG.IL,
  },
  IT: {
    title: VAL_LANG.italian,
    key: KEY_LANG.IT,
  },
  JP: {
    title: VAL_LANG.japan,
    key: KEY_LANG.JP,
  },
  KZ: {
    title: VAL_LANG.kazakh,
    key: KEY_LANG.KZ,
  },
  KR: {
    title: VAL_LANG.korean,
    key: KEY_LANG.KR,
  },
  LT: {
    title: VAL_LANG.lithuanian,
    key: KEY_LANG.LT,
  },
  MY: {
    title: VAL_LANG.malay,
    key: KEY_LANG.MY,
  },
  PL: {
    title: VAL_LANG.polish,
    key: KEY_LANG.PL,
  },
  PT: {
    title: VAL_LANG.portuguese,
    key: KEY_LANG.PT,
  },
  RU: {
    title: VAL_LANG.russian,
    key: KEY_LANG.RU,
  },
  ES: {
    title: VAL_LANG.spanish,
    key: KEY_LANG.ES,
  },
  TR: {
    title: VAL_LANG.turkish,
    key: KEY_LANG.TR,
  },
  UA: {
    title: VAL_LANG.ukrainian,
    key: KEY_LANG.UA,
  },
  VN: {
    title: VAL_LANG.vietnamese,
    key: KEY_LANG.VN,
  },
};

export const flagsLG = new Map<string, string>([
  [LANG_OBJ.AR.title, LANG_OBJ.AR.key],
  [LANG_OBJ.BY.title, LANG_OBJ.BY.key],
  [LANG_OBJ.CN.title, LANG_OBJ.CN.key],
  [LANG_OBJ.NL.title, LANG_OBJ.NL.key],
  [LANG_OBJ.GB.title, LANG_OBJ.GB.key],
  [LANG_OBJ.FR.title, LANG_OBJ.FR.key],
  [LANG_OBJ.DE.title, LANG_OBJ.DE.key],
  [LANG_OBJ.ID.title, LANG_OBJ.ID.key],
  [LANG_OBJ.IL.title, LANG_OBJ.IL.key],
  [LANG_OBJ.IT.title, LANG_OBJ.IT.key],
  [LANG_OBJ.JP.title, LANG_OBJ.JP.key],
  [LANG_OBJ.KZ.title, LANG_OBJ.KZ.key],
  [LANG_OBJ.KR.title, LANG_OBJ.KR.key],
  [LANG_OBJ.LT.title, LANG_OBJ.LT.key],
  [LANG_OBJ.MY.title, LANG_OBJ.MY.key],
  [LANG_OBJ.PL.title, LANG_OBJ.PL.key],
  [LANG_OBJ.PT.title, LANG_OBJ.PT.key],
  [LANG_OBJ.RU.title, LANG_OBJ.RU.key],
  [LANG_OBJ.ES.title, LANG_OBJ.ES.key],
  [LANG_OBJ.TR.title, LANG_OBJ.TR.key],
  [LANG_OBJ.UA.title, LANG_OBJ.UA.key],
  [LANG_OBJ.VN.title, LANG_OBJ.VN.key],
]);

export const LANGUAGES: ObjLanguage[] = [
  {
    title: VAL_LANG.arabic,
    key: KEY_LANG.AR,
  },
  // {
  //   title: VAL_LANG.belarus,
  //   key: KEY_LANG.BY,
  // },
  {
    title: VAL_LANG.chinese,
    key: KEY_LANG.CN,
  },
  // {
  //   title: VAL_LANG.dutch,
  //   key: KEY_LANG.NL,
  // },
  {
    title: VAL_LANG.english,
    key: KEY_LANG.GB,
  },
  // {
  //   title: VAL_LANG.french,
  //   key: KEY_LANG.FR,
  // },
  {
    title: VAL_LANG.german,
    key: KEY_LANG.DE,
  },
  {
    title: VAL_LANG.indonesian,
    key: KEY_LANG.ID,
  },
  // {
  //   title: VAL_LANG.hebrew,
  //   key: KEY_LANG.IL,
  // },
  // {
  //   title: VAL_LANG.italian,
  //   key: KEY_LANG.IT,
  // },
  {
    title: VAL_LANG.japan,
    key: KEY_LANG.JP,
  },
  // {
  //   title: VAL_LANG.kazakh,
  //   key: KEY_LANG.KZ,
  // },
  {
    title: VAL_LANG.korean,
    key: KEY_LANG.KR,
  },
  // {
  //   title: VAL_LANG.lithuanian,
  //   key: KEY_LANG.LT,
  // },
  // {
  //   title: VAL_LANG.malay,
  //   key: KEY_LANG.MY,
  // },
  // {
  //   title: VAL_LANG.polish,
  //   key: KEY_LANG.PL,
  // },
  {
    title: VAL_LANG.portuguese,
    key: KEY_LANG.PT,
  },
  {
    title: VAL_LANG.russian,
    key: KEY_LANG.RU,
  },
  {
    title: VAL_LANG.spanish,
    key: KEY_LANG.ES,
  },
  {
    title: VAL_LANG.turkish,
    key: KEY_LANG.TR,
  },
  // {
  //   title: VAL_LANG.ukrainian,
  //   key: KEY_LANG.UA,
  // },
  // {
  //   title: VAL_LANG.vietnamese,
  //   key: KEY_LANG.VN,
  // },
];
export const STATUS_USER = {
  name: [
    {
      lang: {
        ru: {
          title: 'Начинающий',
          bgImg: 'bg1',
          logoName: 'status1.png',
        },
      },
    },
    {
      lang: {
        ru: {
          title: 'Уверенный',
          bgImg: 'bg2',
          logoName: 'status2.png',
        },
      },
    },
    {
      lang: {
        ru: {
          title: 'Профессионал',
          bgImg: 'bg3',
          logoName: 'status3.png',
        },
      },
    },
    {
      lang: {
        ru: {
          title: 'Продвинутый',
          bgImg: 'bg4',
          logoName: 'status4.png',
        },
      },
    },
    {
      lang: {
        ru: {
          title: 'Понимающий',
          bgImg: 'bg5',
          logoName: 'status5.png',
        },
      },
    },
  ],
};

export const SYSTEM_TEXT = {
  page: {
    menu: {
      lang: {
        ru: {
          startTitle: 'Введение',
          trainingTitle: 'Обучение',
          testingTitle: 'Тестирование',
          journalTitle: 'Журнал',
          resultsTitle: 'Результаты',
          settingsTitle: 'Настройки',
          aboutTitle: 'О продукте',
        },
        en: {
          startTitle: 'Introduction',
          trainingTitle: 'Training',
          testingTitle: 'Testing',
          journalTitle: 'Journal',
          resultsTitle: 'Results',
          settingsTitle: 'Settings',
          aboutTitle: 'About',
        },
        es: {
          startTitle: 'Introducción',
          trainingTitle: 'Entrenamiento',
          testingTitle: 'Prueba',
          journalTitle: 'Diario',
          resultsTitle: 'Resultados',
          settingsTitle: 'Configuración',
          aboutTitle: 'Acerca de',
        },
        fr: {
          startTitle: 'Introduction',
          trainingTitle: 'Formation',
          testingTitle: 'Test',
          journalTitle: 'Journal',
          resultsTitle: 'Résultats',
          settingsTitle: 'Paramètres',
          aboutTitle: 'À propos',
        },
        ar: {
          startTitle: 'مقدمة',
          trainingTitle: 'تدريب',
          testingTitle: 'اختبار',
          journalTitle: 'اليوميات',
          resultsTitle: 'النتائج',
          settingsTitle: 'الإعدادات',
          aboutTitle: 'حول',
        },
        zh: {
          startTitle: '介绍',
          trainingTitle: '训练',
          testingTitle: '测试',
          journalTitle: '日志',
          resultsTitle: '结果',
          settingsTitle: '设置',
          aboutTitle: '关于',
        },
        pt: {
          startTitle: 'Introdução',
          trainingTitle: 'Treinamento',
          testingTitle: 'Teste',
          journalTitle: 'Diário',
          resultsTitle: 'Resultados',
          settingsTitle: 'Configurações',
          aboutTitle: 'Sobre',
        },
        ja: {
          startTitle: '紹介',
          trainingTitle: 'トレーニング',
          testingTitle: 'テスト',
          journalTitle: 'ジャーナル',
          resultsTitle: '結果',
          settingsTitle: '設定',
          aboutTitle: '概要',
        },
        he: {
          startTitle: 'מבוא',
          trainingTitle: 'אימון',
          testingTitle: 'מבחן',
          journalTitle: 'יומן',
          resultsTitle: 'תוצאות',
          settingsTitle: 'הגדרות',
          aboutTitle: 'אודות',
        },
        ko: {
          startTitle: '소개',
          trainingTitle: '훈련',
          testingTitle: '테스트',
          journalTitle: '저널',
          resultsTitle: '결과',
          settingsTitle: '설정',
          aboutTitle: '정보',
        },
      },
    },
  },
};

export const TICKETS_CONSTANT = [
  {
    number: 0,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question1',
        subjects: '1',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question2',
        subjects: '2',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question3',
        subjects: '4',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question4',
        subjects: '7',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question5',
        subjects: '5',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question6',
        subjects: '6',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question7',
        subjects: '3',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket0.question8',
        subjects: '4',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket0.question9_answer1',
          'tickets.ticket0.question9_answer2',
          'tickets.ticket0.question9_answer3',
        ],
        q: 'tickets.ticket0.question9',
        subjects: '2',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket0.question10_answer1',
          'tickets.ticket0.question10_answer2',
          'tickets.ticket0.question10_answer3',
        ],
        q: 'tickets.ticket0.question10',
        subjects: '6',
        state: 2,
        trueA: '2',
      },
    ],
  },
  {
    number: 1,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question1',
        subjects: '5',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question2',
        subjects: '7',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question3',
        subjects: '3',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question4',
        subjects: '1',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question5',
        subjects: '1',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question6',
        subjects: '1',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question7',
        subjects: '2',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket1.question8',
        subjects: '1',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket1.question9_answer1',
          'tickets.ticket1.question9_answer2',
          'tickets.ticket1.question9_answer3',
        ],
        q: 'tickets.ticket1.question9',
        subjects: '3',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket1.question10_answer1',
          'tickets.ticket1.question10_answer2',
          'tickets.ticket1.question10_answer3',
        ],
        q: 'tickets.ticket1.question10',
        subjects: '3',
        state: 1,
        trueA: '1',
      },
    ],
  },
  {
    number: 2,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question1',
        subjects: '7',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question2',
        subjects: '5',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question3',
        subjects: '5',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question4',
        subjects: '6',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question5',
        subjects: '1',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question6',
        subjects: '4',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question7',
        subjects: '3',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket2.question8',
        subjects: '6',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket2.question9_answer1',
          'tickets.ticket2.question9_answer2',
          'tickets.ticket2.question9_answer3',
        ],
        q: 'tickets.ticket2.question9',
        subjects: '5',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket2.question10_answer1',
          'tickets.ticket2.question10_answer2',
          'tickets.ticket2.question10_answer3',
        ],
        q: 'tickets.ticket2.question10',
        subjects: '6',
        state: 2,
        trueA: '1',
      },
    ],
  },
  {
    number: 3,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question1',
        subjects: '1',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question2',
        subjects: '3',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question3',
        subjects: '7',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question4',
        subjects: '2',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question5',
        subjects: '7',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question6',
        subjects: '6',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket3.question7',
        subjects: '7',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket3.question8_answer1',
          'tickets.ticket3.question8_answer2',
          'tickets.ticket3.question8_answer3',
        ],
        q: 'tickets.ticket3.question8',
        subjects: '5',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket3.question9_answer1',
          'tickets.ticket3.question9_answer2',
          'tickets.ticket3.question9_answer3',
        ],
        q: 'tickets.ticket3.question9',
        subjects: '3',
        state: 2,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket3.question10_answer1',
          'tickets.ticket3.question10_answer2',
          'tickets.ticket3.question10_answer3',
        ],
        q: 'tickets.ticket3.question10',
        subjects: '4',
        state: 2,
        trueA: '0',
      },
    ],
  },
  {
    number: 4,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question1',
        subjects: '2',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question2',
        subjects: '2',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question3',
        subjects: '3',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question4',
        subjects: '3',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question5',
        subjects: '3',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question6',
        subjects: '2',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket4.question7',
        subjects: '7',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket4.question8_answer1',
          'tickets.ticket4.question8_answer2',
          'tickets.ticket4.question8_answer3',
        ],
        q: 'tickets.ticket4.question8',
        subjects: '3',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket4.question9_answer1',
          'tickets.ticket4.question9_answer2',
          'tickets.ticket4.question9_answer3',
        ],
        q: 'tickets.ticket4.question9',
        subjects: '4',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket4.question10_answer1',
          'tickets.ticket4.question10_answer2',
          'tickets.ticket4.question10_answer3',
        ],
        q: 'tickets.ticket4.question10',
        subjects: '1',
        state: 0,
        trueA: '0',
      },
    ],
  },
  {
    number: 5,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question1',
        subjects: '1',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question2',
        subjects: '4',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question3',
        subjects: '4',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question4',
        subjects: '6',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question5',
        subjects: '5',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket5.question6',
        subjects: '2',
        trueA: 1,
      },
      {
        type: 2,
        a: [
          'tickets.ticket5.question7_answer1',
          'tickets.ticket5.question7_answer2',
          'tickets.ticket5.question7_answer3',
        ],
        q: 'tickets.ticket5.question7',
        subjects: '2',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket5.question8_answer1',
          'tickets.ticket5.question8_answer2',
          'tickets.ticket5.question8_answer3',
        ],
        q: 'tickets.ticket5.question8',
        subjects: '1',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket5.question9_answer1',
          'tickets.ticket5.question9_answer2',
          'tickets.ticket5.question9_answer3',
        ],
        q: 'tickets.ticket5.question9',
        subjects: '1',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket5.question10_answer1',
          'tickets.ticket5.question10_answer2',
          'tickets.ticket5.question10_answer3',
        ],
        q: 'tickets.ticket5.question10',
        subjects: '3',
        state: 0,
        trueA: '1',
      },
    ],
  },
  {
    number: 6,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question1',
        subjects: '6',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question2',
        subjects: '5',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question3',
        subjects: '2',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question4',
        subjects: '4',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question5',
        subjects: '7',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket6.question6',
        subjects: '5',
        trueA: 1,
      },
      {
        type: 2,
        a: [
          'tickets.ticket6.question7_answer1',
          'tickets.ticket6.question7_answer2',
          'tickets.ticket6.question7_answer3',
        ],
        q: 'tickets.ticket6.question7',
        subjects: '5',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket6.question8_answer1',
          'tickets.ticket6.question8_answer2',
          'tickets.ticket6.question8_answer3',
        ],
        q: 'tickets.ticket6.question8',
        subjects: '5',
        state: 1,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket6.question9_answer1',
          'tickets.ticket6.question9_answer2',
          'tickets.ticket6.question9_answer3',
        ],
        q: 'tickets.ticket6.question9',
        subjects: '7',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket6.question10_answer1',
          'tickets.ticket6.question10_answer2',
          'tickets.ticket6.question10_answer3',
        ],
        q: 'tickets.ticket6.question10',
        subjects: '4',
        state: 0,
        trueA: '0',
      },
    ],
  },
  {
    number: 7,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket7.question1',
        subjects: '1',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket7.question2',
        subjects: '1',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket7.question3',
        subjects: '5',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket7.question4',
        subjects: '2',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket7.question5',
        subjects: '6',
        trueA: 0,
      },
      {
        type: 2,
        a: [
          'tickets.ticket7.question6_answer1',
          'tickets.ticket7.question6_answer2',
          'tickets.ticket7.question6_answer3',
        ],
        q: 'tickets.ticket7.question6',
        subjects: '2',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket7.question7_answer1',
          'tickets.ticket7.question7_answer2',
          'tickets.ticket7.question7_answer3',
        ],
        q: 'tickets.ticket7.question7',
        subjects: '3',
        state: 2,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket7.question8_answer1',
          'tickets.ticket7.question8_answer2',
          'tickets.ticket7.question8_answer3',
        ],
        q: 'tickets.ticket7.question8',
        subjects: '1',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket7.question9_answer1',
          'tickets.ticket7.question9_answer2',
          'tickets.ticket7.question9_answer3',
        ],
        q: 'tickets.ticket7.question9',
        subjects: '7',
        state: 2,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket7.question10_answer1',
          'tickets.ticket7.question10_answer2',
          'tickets.ticket7.question10_answer3',
        ],
        q: 'tickets.ticket7.question10',
        subjects: '2',
        state: 0,
        trueA: '0',
      },
    ],
  },
  {
    number: 8,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket8.question1',
        subjects: '4',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket8.question2',
        subjects: '3',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket8.question3',
        subjects: '4',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket8.question4',
        subjects: '7',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket8.question5',
        subjects: '6',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket8.question6_answer1',
          'tickets.ticket8.question6_answer2',
          'tickets.ticket8.question6_answer3',
        ],
        q: 'tickets.ticket8.question6',
        subjects: '5',
        state: 2,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket8.question7_answer1',
          'tickets.ticket8.question7_answer2',
          'tickets.ticket8.question7_answer3',
        ],
        q: 'tickets.ticket8.question7',
        subjects: '7',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket8.question8_answer1',
          'tickets.ticket8.question8_answer2',
          'tickets.ticket8.question8_answer3',
        ],
        q: 'tickets.ticket8.question8',
        subjects: '7',
        state: 0,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket8.question9_answer1',
          'tickets.ticket8.question9_answer2',
          'tickets.ticket8.question9_answer3',
        ],
        q: 'tickets.ticket8.question9',
        subjects: '5',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket8.question10_answer1',
          'tickets.ticket8.question10_answer2',
          'tickets.ticket8.question10_answer3',
        ],
        q: 'tickets.ticket8.question10',
        subjects: '5',
        state: 2,
        trueA: '0',
      },
    ],
  },
  {
    number: 9,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket9.question1',
        subjects: '6',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket9.question2',
        subjects: '4',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket9.question3',
        subjects: '2',
        trueA: 0,
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question4_answer1',
          'tickets.ticket9.question4_answer2',
          'tickets.ticket9.question4_answer3',
        ],
        q: 'tickets.ticket9.question4',
        subjects: '3',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question5_answer1',
          'tickets.ticket9.question5_answer2',
          'tickets.ticket9.question5_answer3',
        ],
        q: 'tickets.ticket9.question5',
        subjects: '6',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question6_answer1',
          'tickets.ticket9.question6_answer2',
          'tickets.ticket9.question6_answer3',
        ],
        q: 'tickets.ticket9.question6',
        subjects: '7',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question7_answer1',
          'tickets.ticket9.question7_answer2',
          'tickets.ticket9.question7_answer3',
        ],
        q: 'tickets.ticket9.question7',
        subjects: '4',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question8_answer1',
          'tickets.ticket9.question8_answer2',
          'tickets.ticket9.question8_answer3',
        ],
        q: 'tickets.ticket9.question8',
        subjects: '7',
        state: 1,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question9_answer1',
          'tickets.ticket9.question9_answer2',
          'tickets.ticket9.question9_answer3',
        ],
        q: 'tickets.ticket9.question9',
        subjects: '7',
        state: 2,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket9.question10_answer1',
          'tickets.ticket9.question10_answer2',
          'tickets.ticket9.question10_answer3',
        ],
        q: 'tickets.ticket9.question10',
        subjects: '6',
        state: 1,
        trueA: '1',
      },
    ],
  },
  {
    number: 10,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket10.question1',
        subjects: '5',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket10.question2',
        subjects: '7',
        trueA: 1,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket10.question3',
        subjects: '5',
        trueA: 1,
      },
      {
        type: 2,
        a: [
          'tickets.ticket10.question4_answer1',
          'tickets.ticket10.question4_answer2',
          'tickets.ticket10.question4_answer3',
        ],
        q: 'tickets.ticket10.question4',
        subjects: '6',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket10.question5_answer1',
          'tickets.ticket10.question5_answer2',
          'tickets.ticket10.question5_answer3',
        ],
        q: 'tickets.ticket10.question5',
        subjects: '2',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket10.question6_answer1',
          'tickets.ticket10.question6_answer2',
          'tickets.ticket10.question6_answer3',
        ],
        q: 'tickets.ticket10.question6',
        subjects: '4',
        state: 2,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket10.question7_answer1',
          'tickets.ticket10.question7_answer2',
          'tickets.ticket10.question7_answer3',
        ],
        q: 'tickets.ticket10.question7',
        subjects: '1',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket10.question8_answer1',
          'tickets.ticket10.question8_answer2',
          'tickets.ticket10.question8_answer3',
        ],
        q: 'tickets.ticket10.question8',
        subjects: '3',
        state: 2,
        trueA: '1',
      },
      {
        type: 3,
        q: 'tickets.ticket10.question9',
        a: [
          {
            text: 'tickets.ticket10.question9_answer1',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket10.question9_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket10.question9_answer3',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket10.question9_answer4',
            checked: false,
            state: false,
          },
        ],
        subjects: '1',
        state: 0,
      },
      {
        type: 3,
        q: 'tickets.ticket10.question10',
        a: [
          {
            text: 'tickets.ticket10.question10_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket10.question10_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket10.question10_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket10.question10_answer4',
            checked: false,
            state: true,
          },
        ],
        subjects: '1',
        state: 0,
      },
    ],
  },
  {
    number: 11,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket11.question1',
        subjects: '4',
        trueA: 0,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket11.question2',
        subjects: '3',
        trueA: 2,
      },
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket11.question3',
        subjects: '6',
        trueA: 2,
      },
      {
        type: 2,
        a: [
          'tickets.ticket11.question4_answer1',
          'tickets.ticket11.question4_answer2',
          'tickets.ticket11.question4_answer3',
        ],
        q: 'tickets.ticket11.question4',
        subjects: '1',
        state: 0,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket11.question5_answer1',
          'tickets.ticket11.question5_answer2',
          'tickets.ticket11.question5_answer3',
        ],
        q: 'tickets.ticket11.question5',
        subjects: '4',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket11.question6_answer1',
          'tickets.ticket11.question6_answer2',
          'tickets.ticket11.question6_answer3',
        ],
        q: 'tickets.ticket11.question6',
        subjects: '2',
        state: 1,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket11.question7_answer1',
          'tickets.ticket11.question7_answer2',
          'tickets.ticket11.question7_answer3',
        ],
        q: 'tickets.ticket11.question7',
        subjects: '1',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket11.question8_answer1',
          'tickets.ticket11.question8_answer2',
          'tickets.ticket11.question8_answer3',
        ],
        q: 'tickets.ticket11.question8',
        subjects: '6',
        state: 1,
        trueA: '0',
      },
      {
        type: 3,
        q: 'tickets.ticket11.question9',
        a: [
          {
            text: 'tickets.ticket11.question9_answer1',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket11.question9_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket11.question9_answer3',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket11.question9_answer4',
            checked: false,
            state: false,
          },
        ],
        subjects: '1',
        state: 2,
      },
      {
        type: 3,
        q: 'tickets.ticket11.question10',
        a: [
          {
            text: 'tickets.ticket11.question10_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket11.question10_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket11.question10_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket11.question10_answer4',
            checked: false,
            state: true,
          },
        ],
        subjects: '1',
        state: 1,
      },
    ],
  },
  {
    number: 12,
    questions: [
      {
        type: 1,
        a: [1, 2, 3],
        q: 'tickets.ticket12.question1',
        subjects: '3',
        trueA: 0,
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question2_answer1',
          'tickets.ticket12.question2_answer2',
          'tickets.ticket12.question2_answer3',
        ],
        q: 'tickets.ticket12.question2',
        subjects: '2',
        state: 2,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question3_answer1',
          'tickets.ticket12.question3_answer2',
          'tickets.ticket12.question3_answer3',
        ],
        q: 'tickets.ticket12.question3',
        subjects: '4',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question4_answer1',
          'tickets.ticket12.question4_answer2',
          'tickets.ticket12.question4_answer3',
        ],
        q: 'tickets.ticket12.question4',
        subjects: '4',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question5_answer1',
          'tickets.ticket12.question5_answer2',
          'tickets.ticket12.question5_answer3',
        ],
        q: 'tickets.ticket12.question5',
        subjects: '2',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question6_answer1',
          'tickets.ticket12.question6_answer2',
          'tickets.ticket12.question6_answer3',
        ],
        q: 'tickets.ticket12.question6',
        subjects: '4',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question7_answer1',
          'tickets.ticket12.question7_answer2',
          'tickets.ticket12.question7_answer3',
        ],
        q: 'tickets.ticket12.question7',
        subjects: '3',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket12.question8_answer1',
          'tickets.ticket12.question8_answer2',
          'tickets.ticket12.question8_answer3',
        ],
        q: 'tickets.ticket12.question8',
        subjects: '2',
        state: 2,
        trueA: '0',
      },
      {
        type: 3,
        q: 'tickets.ticket12.question9',
        a: [
          {
            text: 'tickets.ticket12.question9_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket12.question9_answer2',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket12.question9_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket12.question9_answer4',
            checked: false,
            state: false,
          },
        ],
        subjects: '1',
        state: 0,
      },
      {
        type: 3,
        q: 'tickets.ticket12.question10',
        a: [
          {
            text: 'tickets.ticket12.question10_answer1',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket12.question10_answer2',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket12.question10_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket12.question10_answer4',
            checked: false,
            state: false,
          },
        ],
        subjects: '1',
        state: 2,
      },
    ],
  },
  {
    number: 13,
    questions: [
      {
        type: 2,
        a: [
          'tickets.ticket13.question1_answer1',
          'tickets.ticket13.question1_answer2',
          'tickets.ticket13.question1_answer3',
        ],
        q: 'tickets.ticket13.question1',
        subjects: '2',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question2_answer1',
          'tickets.ticket13.question2_answer2',
          'tickets.ticket13.question2_answer3',
        ],
        q: 'tickets.ticket13.question2',
        subjects: '6',
        state: 0,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question3_answer1',
          'tickets.ticket13.question3_answer2',
          'tickets.ticket13.question3_answer3',
        ],
        q: 'tickets.ticket13.question3',
        subjects: '7',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question4_answer1',
          'tickets.ticket13.question4_answer2',
          'tickets.ticket13.question4_answer3',
        ],
        q: 'tickets.ticket13.question4',
        subjects: '4',
        state: 1,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question5_answer1',
          'tickets.ticket13.question5_answer2',
          'tickets.ticket13.question5_answer3',
        ],
        q: 'tickets.ticket13.question5',
        subjects: '1',
        state: 2,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question6_answer1',
          'tickets.ticket13.question6_answer2',
          'tickets.ticket13.question6_answer3',
        ],
        q: 'tickets.ticket13.question6',
        subjects: '6',
        state: 0,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question7_answer1',
          'tickets.ticket13.question7_answer2',
          'tickets.ticket13.question7_answer3',
        ],
        q: 'tickets.ticket13.question7',
        subjects: '1',
        state: 1,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket13.question8_answer1',
          'tickets.ticket13.question8_answer2',
          'tickets.ticket13.question8_answer3',
        ],
        q: 'tickets.ticket13.question8',
        subjects: '1',
        state: 2,
        trueA: '2',
      },
      {
        type: 3,
        q: 'tickets.ticket13.question9',
        a: [
          {
            text: 'tickets.ticket13.question9_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket13.question9_answer2',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket13.question9_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket13.question9_answer4',
            checked: false,
            state: true,
          },
        ],
        subjects: '1',
        state: 2,
      },
      {
        type: 3,
        q: 'tickets.ticket13.question10',
        a: [
          {
            text: 'tickets.ticket13.question10_answer1',
            checked: false,
            state: true,
          },
          {
            text: 'tickets.ticket13.question10_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket13.question10_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket13.question10_answer4',
            checked: false,
            state: false,
          },
        ],
        subjects: '1',
        state: 1,
      },
    ],
  },
  {
    number: 14,
    questions: [
      {
        type: 2,
        a: [
          'tickets.ticket14.question1_answer1',
          'tickets.ticket14.question1_answer2',
          'tickets.ticket14.question1_answer3',
        ],
        q: 'tickets.ticket14.question1',
        subjects: '5',
        state: 0,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question2_answer1',
          'tickets.ticket14.question2_answer2',
          'tickets.ticket14.question2_answer3',
        ],
        q: 'tickets.ticket14.question2',
        subjects: '5',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question3_answer1',
          'tickets.ticket14.question3_answer2',
          'tickets.ticket14.question3_answer3',
        ],
        q: 'tickets.ticket14.question3',
        subjects: '3',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question4_answer1',
          'tickets.ticket14.question4_answer2',
          'tickets.ticket14.question4_answer3',
        ],
        q: 'tickets.ticket14.question4',
        subjects: '6',
        state: 0,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question5_answer1',
          'tickets.ticket14.question5_answer2',
          'tickets.ticket14.question5_answer3',
        ],
        q: 'tickets.ticket14.question5',
        subjects: '5',
        state: 2,
        trueA: '1',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question6_answer1',
          'tickets.ticket14.question6_answer2',
          'tickets.ticket14.question6_answer3',
        ],
        q: 'tickets.ticket14.question6',
        subjects: '6',
        state: 1,
        trueA: '2',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question7_answer1',
          'tickets.ticket14.question7_answer2',
          'tickets.ticket14.question7_answer3',
        ],
        q: 'tickets.ticket14.question7',
        subjects: '7',
        state: 1,
        trueA: '0',
      },
      {
        type: 2,
        a: [
          'tickets.ticket14.question8_answer1',
          'tickets.ticket14.question8_answer2',
          'tickets.ticket14.question8_answer3',
        ],
        q: 'tickets.ticket14.question8',
        subjects: '7',
        state: 2,
        trueA: '2',
      },
      {
        type: 3,
        q: 'tickets.ticket14.question9',
        a: [
          {
            text: 'tickets.ticket14.question9_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question9_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question9_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question9_answer4',
            checked: false,
            state: true,
          },
        ],
        subjects: '1',
        state: 0,
      },
      {
        type: 3,
        q: 'tickets.ticket14.question10',
        a: [
          {
            text: 'tickets.ticket14.question10_answer1',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question10_answer2',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question10_answer3',
            checked: false,
            state: false,
          },
          {
            text: 'tickets.ticket14.question10_answer4',
            checked: false,
            state: true,
          },
        ],
        subjects: '1',
        state: 2,
      },
    ],
  },
];
